import {
    Card, CardContent, TextField, Button, makeStyles, Switch, FormLabel, RadioGroup, FormControlLabel, Radio, CircularProgress
} from '@material-ui/core';
import { useEffect, useState } from 'react';
import axiosWithAuthInterceptor from '../util/axiosWithAuthInterceptor';
import { getRoles } from '../auth-provider/ra-auth-jwt';

const gateway = [
    {
        value: 'PAYPING',
        label: 'پی‌پینگ',
    },
    {
        value: 'VANDAR',
        label: 'وندار',
    },
    {
        value: 'LIMOOME_ZIFY',
        label: 'زیفای',
    },
    {
        value: 'LIMOSOFT_PAYPING',
        label: 'LIMOSOFT پی‌پینگ',
    },
    {
        value: 'SIBDIET_PAYPING',
        label: 'SIBDIET پی‌پینگ',
    },
];

export function CreatePaymentGatewayManager() {
    const [serverState, setServerState] = useState({ loading: false, message: '', hasError: false });
    const [values, setValues] = useState({
        gateway: 'PAYPING',
        token: '',
        isEnabled: false
    })



    const changeSelectedValue = (getway: string, authTokenId: string, e: any) => {
    }

    const submit = async () => {
        setServerState({ loading: true, message: '', hasError: false })
        let token: any = localStorage.getItem('credentials')
        axiosWithAuthInterceptor({
            url: `${process.env.REACT_APP_LEMONADE_SERVER}/api/authTokens`,
            data: values,
            method: 'POST'
        }).then((res: any) => {
            setServerState({ loading: false, message: 'با موفقیت انجام شد', hasError: false })
        }).catch((e: any) => {
            setServerState({ loading: false, message: 'خطا در ثبت', hasError: true })
        })

    }



    useEffect(() => {

        let roles = getRoles();
        let isPaymentManager = roles.some((r: any) => r === `${process.env.REACT_APP_AUTH_SERVICE}.payment_manager`)
        if (!isPaymentManager)
            window.location.href = '/'
    }, [])

    return (
        <Card>
            <CardContent>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '1rem' }}>
                    <TextField
                        fullWidth
                        label="درگاه"
                        size="medium"
                        id="outlined-select-currency-native"
                        select
                        onChange={(e: any) => setValues({ ...values, gateway: e.target.value })}
                        variant="outlined"
                        value={values.gateway}
                    >
                        {gateway.map((option) => (
                            <option key={option.value} value={option.value}>
                                {option.label}
                            </option>
                        ))}
                    </TextField>

                    <div style={{ display: 'flex', justifyContent: 'center', width: '100%', alignItems: 'center', fontFamily: 'IranSans-Bold' }}>
                        <p>فعال/غیرفعال</p>
                        <Switch
                            checked={values.isEnabled}
                            disabled
                            onChange={(e: any) => setValues({ ...values, isEnabled: !values.isEnabled })}
                            color="primary"
                            name="checkedA"
                            inputProps={{ 'aria-label': 'secondary checkbox' }}
                        />
                    </div>
                </div>
                <TextField fullWidth onChange={(e: any) => setValues({ ...values, token: e.target.value })} value={values.token} size="medium" label="توکن درگاه" variant="outlined"></TextField>
                <div style={{ display: 'flex', alignItems: 'center', marginTop: '2rem', justifyContent: 'flex-start', gap: '1rem' }}>
                    <Button onClick={() => { window.location.href = `${process.env.REACT_APP_AUTH_PUBLIC_PATH}/#/payment-gateway-manager/update` }} style={{ color: '#fff' }} variant="contained" color="primary">بازگشت</Button>
                    <Button disabled={values.token ? false : true} onClick={() => submit()} variant="contained" style={{ color: '#fff' }} color="primary">ثبت</Button>
                    {
                        !serverState.loading && serverState.hasError && serverState.message ?
                            <section style={{ display: 'flex', backgroundColor: 'red', color: '#fff', padding: '5px', borderRadius: '8px', fontFamily: 'IranSans-Bold', fontSize: '14px', direction: 'rtl' }}>
                                {serverState.message}
                            </section>
                            :
                            <div></div>
                    }
                    {
                        !serverState.loading && !serverState.hasError && serverState.message ?
                            <section style={{ display: 'flex', backgroundColor: '#4fcc12', color: '#fff', padding: '5px', borderRadius: '8px', fontFamily: 'IranSans-Bold', fontSize: '14px', direction: 'rtl' }}>
                                {serverState.message}
                            </section>
                            :
                            <div></div>
                    }
                </div>
            </CardContent>
        </Card >
    )
}